import React from 'react';
import styles from './Field.module.css';

const AlertIcon = (props) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" aria-hidden="true" {...props}>
        <circle cx="12" cy="12" r="9"/>
        <path d="M12 8v5M12 16h.01"/>
    </svg>
);

/**
 * Generic field layout: label, a control slot, then helper or error text.
 * TextInput/Select/Textarea/Checkbox wrap this so most call sites never need
 * to reach for Field directly - it's exposed for custom controls.
 */
const Field = ({id, label, optional, helperText, error, children}) => {
    const helpId = helperText ? `${id}-help` : undefined;
    const errId = error ? `${id}-error` : undefined;

    return (
        <div className={styles.field}>
            {label && (
                <label htmlFor={id} className={styles.label}>
                    {label}
                    {optional && <span className={styles.optional}> (optional)</span>}
                </label>
            )}
            {children}
            {error ? (
                <span id={errId} className={styles.errorText}>
                    <AlertIcon className={styles.errorIcon}/>{error}
                </span>
            ) : helperText ? (
                <span id={helpId} className={styles.helperText}>{helperText}</span>
            ) : null}
        </div>
    );
};

export const describedBy = (id, {helperText, error} = {}) => {
    if (error) return `${id}-error`;
    if (helperText) return `${id}-help`;
    return undefined;
};

export default Field;
